import { useNavigate } from 'react-router-dom';

import { HeroBanner } from '../components/HeroBanner';
import { KioskFrame } from '../components/KioskFrame';
import { Mascot } from '../components/Mascot';
import { TileCard } from '../components/TileCard';
import { SupIcon, ThumbIcon, TicketIcon, YachtIcon } from '../components/TileIcons';
import { useKiosk } from '../lib/session';

/**
 * 主功能 — 2026-08-18 設計稿 p.5 的 2×2 圖示卡。
 *
 * 行程推薦 · 搭船遊港 · 水上設施 · 查詢票券。
 *
 * ## 與舊版四項的對應
 *
 *   我想搭船        → 行程推薦（/recommend，未變）
 *   我自己選        → 搭船遊港（/browse?category=trip，加了分類過濾）
 *   （新增）        → 水上設施（/browse?category=experience）
 *   我已購票，要報到 → 查詢票券（/checkin，未變）
 *
 * 「我自己選」原本一次列出遊艇與水上活動，設計稿把兩者拆成獨立入口，故改帶分類。
 *
 * ## 「認識安平」不在這四格裡
 *
 * 設計稿的四格沒有它（業主 2026-08-19 指示以設計稿為準）。**路由 /spots 保留**、
 * 畫面與景點內容都還在，只是首頁不再有入口——真要整個下架是另一個決定，而移除
 * 一個仍有內容的功能不該是改版面時順手做掉的。
 */
export function HomeScreen(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useKiosk();

  return (
    <KioskFrame bleed>
      <HeroBanner height={430}>
        <Mascot size={220} pose="smile" />
      </HeroBanner>

      <h1 className="k-h1" style={{ textAlign: 'center', marginTop: 8, marginBottom: 6 }}>
        {t('home.welcome')}
      </h1>
      <p className="k-subtitle k-subtitle--flanked">{t('home.subtitle')}</p>

      <div className="k-tiles k-tiles--2 k-tiles--menu">
        <TileCard
          icon={<ThumbIcon />}
          title={t('menu.recommend')}
          sub={t('menu.recommendSub')}
          iconHeight={300}
          onClick={() => navigate('/recommend')}
        />
        <TileCard
          icon={<YachtIcon />}
          title={t('menu.cruise')}
          sub={t('menu.cruiseSub')}
          iconHeight={300}
          onClick={() => navigate('/browse?category=trip')}
        />
        <TileCard
          icon={<SupIcon />}
          title={t('menu.water')}
          sub={t('menu.waterSub')}
          iconHeight={300}
          onClick={() => navigate('/browse?category=experience')}
        />
        <TileCard
          icon={<TicketIcon />}
          title={t('menu.ticket')}
          sub={t('menu.ticketSub')}
          iconHeight={300}
          onClick={() => navigate('/checkin')}
        />
      </div>
    </KioskFrame>
  );
}
